<template>
    <div class="pb-4">
        <div :class="{ 'pt-6': i !== 0 }" v-for="(typeItem, i) in benefitsList">
            <h3 class="font-bold text-xl pb-4">{{ typeItem.title }}</h3>

            <template v-for="orderList in typeItem.order">
                <h3 class="font-bold text-md pb-4" v-if="typeItem.order.length !== 1">{{ orderList.title }}</h3>
                <CaseBox :caseBox="getCaseBox(orderList.order)"></CaseBox>
            </template>

        </div>
    </div>
</template>

<script setup>
import CaseBox from '@/components/cloudCounter/CaseBox.vue'

import { defineProps, onMounted, ref, toRef, computed } from 'vue';
import AplCatlCode from '@/json/aplCatlCode';
import { useStore } from 'vuex';

const store = useStore();

const props = defineProps({
    result: {
        type: Object,
        required: true,
    },
});
const resultData = toRef(props, 'result');

const code = ref(AplCatlCode.BENEIFCIARY);
const benefitsList = computed(() => {
    const benefitsList = store.state.services.changeItemsResult[code.value].benefitsList;
    const selectedItems = store.state.services.changeItemsResult[code.value].choosedOptions;

    return benefitsList.filter(e => selectedItems.includes(e.key));
});

const filterData = (value) => {
    if (typeof value === 'string') {
        return value !== ''
    } else if (typeof value === 'object') {
        // return Object.values(value).reduce((a, b) => a + b) !== ''
        // return Object.values(value).every(e => Boolean(e))
        const str = Object.values(value).reduce((a, b) => a + b)
        return Boolean(str) && str !== 'null'
    }
    return false
}

const getCaseBox = (ary) => {
    const _obj = {
        boxList: [],
    };

    ary.forEach(element => {
        let list = element.fields.filter(item => item.CheckVisible !== false && filterData(item.value));

        list = list.map(item => {
            if (item.id === 'ratio' && Number(item.value) > 0) {
                return { ...item, value: item.value + '%' }
            }
            return item;
        })

        _obj.boxList.push({
            title: element.fields.find(item => item.id === 'name').value,
            list: list,
        });
    });

    return _obj;
}

</script>
<style scoped lang="scss"></style>
